import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import DateSelect from "../Date/DateSelect";
import TimePicker from "../TimePicker/TimePicker";

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 413px) {
    flex-direction: column;
    width: 100%;

    .date-select-wrapper {
      margin-right: 0 !important;

      .date-picker-wrapper {
        width: 100%;
      }
    }

    .time-wrapper {
      margin-top: 10px;
    }
  }
`;

const DateAndTime = (props) => {
  const {
    dateClassName,
    timeClassName,
    validate,
    onValidate,
    onChange,
    maxDate,
    minDate,
    readOnly,
    defaultDate,
    defaultTime,
    onError,
    timeIntervals = 1,
  } = props;

  const [eventDate, setEventDate] = useState(new Date());
  const [eventTime, setEventTime] = useState(new Date());
  const [showErrorDate, setShowErrorDate] = useState(false);
  const [isValidDate, setIsValidDate] = useState(true);

  const [maxTime, setMaxTime] = useState(null);

  const validateDateAndTime = useCallback(() => {
    const hasErrors = eventTime === "";

    onValidate(!hasErrors, {
      eventDate: eventDate,
      eventTime: eventTime,
    });
  }, [eventTime, onValidate, eventDate]);

  const onChangeDate = (date) => {
    onChange(true, {
      eventDate: date,
      eventTime: eventTime,
    });
  };

  useEffect(() => {
    if (moment(eventDate).startOf("day").isSame(moment().startOf("day"))) {
      setMaxTime(moment().toDate());
    } else {
      setMaxTime(moment(eventDate).endOf("day").toDate());
    }
  }, [eventDate, maxDate]);

  useEffect(() => {
    setEventDate(defaultDate ?? new Date());
  }, [defaultDate]);

  useEffect(() => {
    setEventTime(defaultTime ?? new Date());
  }, [defaultTime]);

  useEffect(() => {
    if (validate) {
      validateDateAndTime();
    }
  }, [validate, validateDateAndTime]);

  const errorHandling = {
    showErrorDate: showErrorDate,
    setShowErrorDate: setShowErrorDate,
    isValidDate: isValidDate,
    setIsValidDate: setIsValidDate,
  };

  const handleTimeChange = (value) => {
    setEventTime(value);

    onChange(true, {
      eventDate: eventDate,
      eventTime: value,
    });
  };

  return (
    <StyledWrapper data-testid="date-time">
      <div className={dateClassName}>
        <DateSelect
          eventDate={eventDate}
          maxDate={maxDate}
          minDate={minDate}
          setEventDate={setEventDate}
          errorHandling={errorHandling}
          onChange={onChangeDate}
          readOnly={readOnly}
        />
      </div>
      <div className={timeClassName}>
        <TimePicker
          id="time-picker"
          onChange={handleTimeChange}
          value={eventTime}
          readOnly={readOnly}
          maxTime={maxTime}
          onError={(error) => onError(error)}
          timeIntervals={timeIntervals}
        />
      </div>
    </StyledWrapper>
  );
};

export default withTheme(DateAndTime);
